import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import _enums from '../../../common/enums';

import AuthPanelActions from './actions';

const initialState = Immutable({
  userFieldName:  '',
  userFieldValue: '',

  passwordFieldName:  '',
  passwordFieldValue: '',

  rememberMeFieldName:  '',
  rememberMeFieldValue: false,

  totpCodeFieldName:  '',
  totpCodeFieldValue: false,

  loginType:          _enums.loginTypes.NONE,
  secondaryLoginType: _enums.loginTypes.NONE,

  cesSupportUrl:   '',
  cesAuthLoginUrl: '',
  skipCountdown:   null,
});

export default createReducer((on) => {
  on(
    AuthPanelActions.bootstrap,
    (
      state,
      {
        userFieldName,
        userFieldValue,
        passwordFieldName,
        passwordFieldValue,
        rememberMeFieldName,
        rememberMeFieldValue,
        totpCodeFieldName,
        totpCodeFieldValue,
        cesSupportUrl,
      }
    ) => {
      return state
        .set('userFieldName', userFieldName)
        .set('userFieldValue', userFieldValue)
        .set('passwordFieldName', passwordFieldName)
        .set('passwordFieldValue', passwordFieldValue)
        .set('rememberMeFieldName', rememberMeFieldName)
        .set('rememberMeFieldValue', rememberMeFieldValue)
        .set('totpCodeFieldName', totpCodeFieldName)
        .set('totpCodeFieldValue', totpCodeFieldValue)
        .set('cesSupportUrl', cesSupportUrl);
    }
  );

  on(AuthPanelActions.updateField, (state, { fieldId, value }) => {
    return state.set(fieldId, value);
  });

  on(
    AuthPanelActions.onEmailSubmitRequestSuccess,
    (state, { loginType, secondaryLoginType, skipCountdown, cesSupportUrl, cesAuthLoginUrl }) => {
      return state
        .set('loginType', loginType)
        .set('secondaryLoginType', secondaryLoginType)
        .set('skipCountdown', skipCountdown)
        .set('cesSupportUrl', cesSupportUrl)
        .set('cesAuthLoginUrl', cesAuthLoginUrl);
    }
  );
}, initialState);
